module.exports = __webpack_public_path__ + "img/CECA_NK.2bbae455.png";